export const useExperimentVariant = () => ({ showVariant: false });
